import {authService, userService} from "../../../client/connection/Services";
import {iFrameState} from "../../services/IFrameState";
import {Dispatchable} from "../../../stem-core/src/base/Dispatcher";
import {Messages} from "../../Messages";
import {startDashboardFlow, startFlow} from "./startFlow";
import {AUTHENTICATION_PANEL_TYPE, PANEL_VARIANT} from "../../../blink-sdk/Constants";


export class FlowController extends Dispatchable {
    actionButtonTestId = "";
    actionButtonDefaultAnid = null;
    logInFooterDefaultAnid = null;

    onClick(event) {
        if (!authService.isAuthenticated()) {
            this.onClickNotAuthenticated();
        } else {
            userService.ensureUserDataRequested(() => {
                // We really want to be sure that this gets executed after blink service updates the sdk user data.
                setTimeout(() => this.onClickAuthenticated());
            });
        }
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false;
    }

    onClickAuthenticated() {}

    onClickNotAuthenticated() {
        startFlow(null, {
            type: AUTHENTICATION_PANEL_TYPE,
            variant: PANEL_VARIANT.skipCTA,
        });
    }

    onLoginClick(event) {
        this.onClick(event);
    }

    onManageAccountClick(event) {
        event.preventDefault();
        event.stopPropagation();
        event.returnValue = false;
        startDashboardFlow();
    }

    getHeaderDefaultText() {
        return iFrameState.panelText || "";
    }

    getActionButtonDefaultLabel() {
        return iFrameState.panelButtonText;
    }

    getLoginFooterMessage() {
        return Messages.alreadyHaveAnAccount;
    }
}

